export default function yearsFilter(value) {
  return `${value * 100} %`
}
